import React from 'react'
import OrderlikeLayout from '../../../../generic/Layouts/OrderlikeLayout'
import SettingsNav from './Components/Nav/SettingsNav'
import { Route, Routes } from 'react-router-dom'
import AccountIndex from './Account/AccountIndex'
import PreferencesIndex from './Preferences/PreferencesIndex'
import FeatureControlMain from './FeatureControl/FeatureControlMain'
import { useTranslation } from 'react-i18next'
import { SecurityMain } from './Security'

type Props = {}

const SettingsIndex = (props: Props) => {
  const [t] = useTranslation(['settings'])
  return (
    <OrderlikeLayout label={t("title")}>
      <SettingsNav />
      <Routes>
        <Route path='account' element={<AccountIndex/>} />
        <Route path='preferences' element={<PreferencesIndex/>} />
        <Route path='feature-control' element={<FeatureControlMain/>} />
        <Route path='security' element={<SecurityMain/>} />
      </Routes>
    </OrderlikeLayout>
  )
}

export default SettingsIndex